import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import readTextFile from '../utils/readTextFile'

function fromEntries(pairs) {
  return pairs.reduce((acum, pair) => {
    acum[pair[0]] = pair[1]
    return acum
  }, {})
}

@Component({
  standalone: false,
  selector: 'app-campaign-creation-menu',
  templateUrl: './campaign-creation-menu.component.html',
  styleUrls: ['./campaign-creation-menu.component.scss'],
})
export class CampaignCreationMenuComponent implements OnInit {
  @Input() keyIndicator: string = null
  @Input() allPois = []
  @Input() pois = []
  @Input() active = false
  @Output() onToggleActive = new EventEmitter<boolean>()
  @Output() onConfirm = new EventEmitter()
  @Output() onClear = new EventEmitter()
  @Output() onEdit = new EventEmitter<any[]>()
  dropdownOpen = false

  get totalReach() {
    const values = this.allPois
      .filter((p) =>
        this.allPoisSelected ? true : this.pois.indexOf(p.id) !== -1,
      )
      .map((p) => p[this.keyIndicator])

    return values.reduce((acc, value) => acc + Number(value || 0), 0)
  }

  get poiAddressMap() {
    const data = this.allPois
      .filter((p) => this.pois.indexOf(p.id) !== -1)
      .map((p) => [p.id, p.properties.address])
    return fromEntries(data)
  }

  get allPoisSelected() {
    return this.pois.length === 1 && this.pois[0] === 'all'
  }

  open = false

  constructor(private translate: TranslateService) {}

  ngOnInit() {}

  activate() {
    this.onToggleActive.emit(true)
  }

  clear() {
    this.onClear.emit()
  }

  discard() {
    this.open = false
    this.onToggleActive.emit(false)
    this.onClear.emit()
  }

  confirm() {
    this.open = false
    this.onConfirm.emit()
  }

  formatID(id: string) {
    return id.split(':').pop()
  }

  async uploadPOIs(input: HTMLInputElement) {
    const files = input.files
    if (!files?.length) return

    const text = await readTextFile(files[0])
    // Reset so the same file can be re-uploaded
    input.value = ''

    const lines = text
      .split(/\r\n|\n/)
      .map((l) => l.trim())
      .filter(Boolean)

    // Skip header row if present
    if (lines.length && /^poi[_\s]?id$/i.test(lines[0])) {
      lines.shift()
    }

    const allpoiIds = this.allPois.map((p) => [
      p.id,
      this.formatID(String(p.id)),
    ])
    const foundPois = []
    for (const line of lines) {
      // Take first column in case of multi-column CSV
      const rawId = line.split(',')[0].trim()
      const id = this.formatID(rawId)
      const poi = allpoiIds.find((p) => p[1] === id)
      if (poi) {
        foundPois.push(poi[0])
      }
    }
    this.onEdit.emit(foundPois)
  }

  removeSinglePOI(id) {
    const pois = this.pois.filter((p) => p !== id)
    this.onEdit.emit(pois)
  }

  selectAll() {
    this.onEdit.emit(['all'])
  }

  getPOIName(id) {
    return id === 'all'
      ? this.translate.instant('All filtered POIs')
      : `POI ${this.formatID(id)}`
  }
}
